module.exports = "<home *ngIf='mobileModeAppRoot==\"desktop\"'></home>\r\n<mobile-home *ngIf='mobileModeAppRoot==\"phone\"'></mobile-home>\r\n\r\n";